module.exports = __webpack_public_path__ + "static/img/20230428.7516da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230428.png
// module id = cuzF
// module chunks = 0